import {
  companiesRepo,
  organizationsRepo,
  tenantRepo,
  usersRepo,
} from '@/constants/providers';
import { DeleteProfileImageJson } from '@/modules/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { UserKey } from './types';

export const useUploadProfileUserPicture = () =>
  useMutation<unknown, unknown, FormData>((data) =>
    usersRepo.uploadProfilePicture(data),
  );

export const useDeleteProfileUserPicture = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: () => usersRepo.deleteProfilePicture(),
    onSuccess: () => {
      queryClient.invalidateQueries(UserKey.CURRENT_USER);
      toast.success(t('success_profile_image_deleted'));
    },
    onError: () => toast.error(t('error_deleting_profile_image')),
  });
};

export const useUploadProfileCompanyPicture = () =>
  useMutation<unknown, unknown, FormData>((data) =>
    companiesRepo.uploadProfilePicture(data),
  );

export const useDeleteProfileCompanyPicture = () =>
  useMutation<unknown, unknown, DeleteProfileImageJson>((deleteProfileImage) =>
    companiesRepo.deleteProfilePicture(deleteProfileImage),
  );

export const useUploadProfileOrganizationPicture = () =>
  useMutation<unknown, unknown, FormData>((data) =>
    organizationsRepo.uploadProfilePicture(data),
  );

export const useDeleteProfileOrganizationPicture = () =>
  useMutation<unknown, unknown, DeleteProfileImageJson>((deleteProfileImage) =>
    organizationsRepo.deleteProfilePicture(deleteProfileImage),
  );

export const useUploadProfileTenantPicture = () =>
  useMutation<unknown, unknown, FormData>((data) =>
    tenantRepo.uploadProfilePicture(data),
  );

export const useDeleteProfileTenantPicture = () =>
  useMutation<unknown, unknown, DeleteProfileImageJson>(
    tenantRepo.deleteProfilePicture,
  );
